/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import {
  TcsRealtimeTrackingRecord,
  TcsRealtimeTrackingProps,
} from 'src/store/generated/tcs-realtime-tracking-record.generated';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface UserApplicationSettingsProps {
  tcsRealtimeTracking: TcsRealtimeTrackingProps;
}

export class UserApplicationSettingsRecord extends Record<UserApplicationSettingsProps>({
  tcsRealtimeTracking: null as any,
}) {
  public static fromJS(json: { tcsRealtimeTracking: any }): UserApplicationSettingsRecord {
    if (json == null) {
      throw new Error('UserApplicationSettingsRecord.fromJS: parameter cannot be null');
    }
    return new UserApplicationSettingsRecord({
      tcsRealtimeTracking: new TcsRealtimeTrackingRecord(
        getFromOrThrow(
          json,
          (j) => j.tcsRealtimeTracking,
          'UserApplicationSettingsJson.tcsRealtimeTracking',
        ),
      ),
    });
  }

  public static fromJSUnsafe(json: {
    tcsRealtimeTracking: any;
  }): [UserApplicationSettingsRecord, Error[]] {
    if (json == null) {
      throw new Error('UserApplicationSettingsRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new UserApplicationSettingsRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      tcsRealtimeTracking: tryOrDefault(
        () =>
          new TcsRealtimeTrackingRecord(
            getFromOrThrow(
              json,
              (j) => j.tcsRealtimeTracking,
              'UserApplicationSettingsJson.tcsRealtimeTracking',
            ),
          ),
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: UserApplicationSettingsProps) {
    super(props);
    if (props == null) {
      throw new Error('UserApplicationSettingsRecord constructor parameter cannot be null');
    }
  }
}

export abstract class UserApplicationSettingsViewModelBase implements UserApplicationSettingsProps {
  protected readonly _props: UserApplicationSettingsProps;
  private _json?: UserApplicationSettingsProps;

  get tcsRealtimeTracking(): TcsRealtimeTrackingProps {
    return this._props.tcsRealtimeTracking;
  }

  constructor(props: UserApplicationSettingsProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        tcsRealtimeTracking: this._props.tcsRealtimeTracking,
      };
    }
    return this._json;
  }
}
